import { ChatbotMgrProvider } from '@/common/ai/ChatbotMgrContext';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { KrThemeProvider } from '@/common/theme/KrThemeContext';
import { useMemo } from 'react';
import { Routes, useLocation } from 'react-router-dom';
import { Chatbot } from './common/ai/Chatbot';
import { DialogProvider } from './common/dialog/DialogContext';
import { SideNav } from './common/sideNav/SideNav';

// Vite replacement for require.context: eager loads all matching route modules
// NOTE: '/src/*/*.routes.jsx' only matches one folder deep under src
// If your routes are deeper, use '/src/**/*.routes.jsx' instead.
const routeModules = import.meta.glob('/src/**/*.routes.jsx', { eager: true });

const buildRoutesForOrg = (org) =>
  Object.entries(routeModules)
    .filter(([key]) => {
      if (!key.includes('/org/')) return true;
      return key.includes(`/${org.toLowerCase()}/`);
    })
    .sort(([a], [b]) => b.includes('/org/') - a.includes('/org/'))
    .map(([, mod]) => mod.default)
    .flat();

const App = () => {
  const { org } = usePrincipal();
  const location = useLocation();

  const routes = useMemo(() => buildRoutesForOrg(org), [org]);

  return (
    <KrThemeProvider>
      <DialogProvider>
        <ChatbotMgrProvider>
          <SideNav>
            {/* Using location.search as the key forces the main UI content to rerender on each navigation. This is important for scenarios
                where two consecutive navigations use the same UI, such as MD Org Detail -> SC Org Detail */}
            <Routes key={location.search}>{routes}</Routes>
            <Chatbot />
          </SideNav>
        </ChatbotMgrProvider>
      </DialogProvider>
    </KrThemeProvider>
  );
};

export default App;
